<template class="mr-3">
  <div class="card">
    <a-skeleton v-if="loading" :active="true" :paragraph="{ rows: 4 }" />

    <div v-else class="card-body">
      <div class="d-flex justify-content-between align-items-center mt-2 my-2">
        <div class="d-flex align-items-center">
          <span class="mr-2">{{
            $t("paiement.filtrerParStatut") || "Filtrer par statut:"
          }}</span>
          <a-switch
            v-model="showActiveOnly"
            :checked-children="$t('paiement.actives') || 'Actives'"
            :un-checked-children="$t('paiement.toutes') || 'Toutes'"
            @change="onStatusFilterChange"
          />
        </div>
      </div>
      <a-input-search
        v-model="searchTerm"
        :placeholder="$t('inscription.chercherParActivite')"
        @input="onSearch"
      />
      <br />

      <a-directory-tree default-expand-all @select="onSelect">
        <a-tree-node
          v-for="(service, service_id) in services"
          :key="service_id"
          :title="service"
          v-if="
            activitiesCache[service_id] &&
            activitiesCache[service_id].length > 0
          "
        >
          <a-icon slot="icon" type="tags" />
          <a-tree-node
            v-for="activity in activitiesCache[service_id]"
            :key="activity._id"
            :title="activity.designation"
            is-leaf
          >
            <a-icon slot="icon" type="tag" v-if="activity.status == 'active'" />
            <a-icon slot="icon" type="tag" class="text-danger" v-else />
          </a-tree-node>
        </a-tree-node>
      </a-directory-tree>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import router from "@/router";
import apiClient from "@/services/axios";
export default {
  data() {
    return {
      activitiessData: {},
      activitiesCache: {},
      services: {},
      loading: true,
      showActiveOnly: true, // Default to showing only active activities
      searchTerm: "", // Track current search term
      debouncedApplyFilters: null,
    };
  },
  created() {
    this.debouncedApplyFilters = _.debounce((v) => this.applyFilters(v), 300);
  },
  beforeCreate() {
    apiClient
      .post("/services/filter", {
        query: {
          status: "active",
        },
        aggregation: {
          $project: {
            _id: 1,
            name: 1,
          },
        },
      })
      .then((res) => {
        let services = Object();
        res.data.forEach((element) => {
          services[element._id] = element.name;
        });
        this.services = services;
      })

      .catch((e) => this.$message.error(this.$t("error.aucService")));
    apiClient
      .post("/activities/filter", {
        query: {},
        aggregation: {
          $project: {
            _id: 1,
            service: 1,
            designation: 1,
            status: 1,
          },
        },
      })
      .then((res) => {
        const { data } = res;
        this.activitiesList = data;
        this.activitiessData = _.mapValues(
          _.groupBy(data, "service"),
          (clist) => clist.map((elem) => _.omit(elem, "service"))
        );
        this.activitiesCache = { ...this.activitiessData };
        this.applyFilters(); // Apply initial filter
      })
      .catch((e) => this.$message.error(this.$t("error.aucActivite")))
      .finally(() => (this.loading = false));
  },
  methods: {
    onSelect(keys, event) {
      const key = keys[0];
      for (const activitylist in this.activitiessData) {
        this.activitiessData[activitylist].forEach((ac) => {
          if (key == ac._id) router.push(`/PaiementActivite/${key}`);
        });
      }
    },
    onSearch(event) {
      const value = event.target.value;
      this.searchTerm = value;
      this.debouncedApplyFilters(value);
    },
    onStatusFilterChange() {
      this.applyFilters(this.searchTerm);
    },
    applyFilters(searchTerm = "") {
      let filteredData = { ...this.activitiessData };

      // Apply status filter
      if (this.showActiveOnly) {
        filteredData = Object.fromEntries(
          Object.entries(filteredData).map(([key, value]) => [
            key,
            value.filter((elem) => elem.status === "active"),
          ])
        );
      }

      // Apply search filter
      if (searchTerm) {
        filteredData = Object.fromEntries(
          Object.entries(filteredData).map(([key, value]) => [
            key,
            value.filter((elem) =>
              elem.designation.toLowerCase().includes(searchTerm.toLowerCase())
            ),
          ])
        );
      }

      this.activitiesCache = filteredData;
    },
  },
  beforeDestroy() {
    this.debouncedApplyFilters.cancel();
  },
};
</script>
<style scoped>
.card >>> .ant-tree {
  font-size: 17px;
}
.card >>> .ant-tree-title {
  font-weight: 500;
}
</style>
